import { useNotificationContext } from "@circle-react-shared/Notifications/NotificationContext";
import { useNotificationTabs } from "@circle-react-shared/Notifications/useNotificationTabs";

import { NotificationTabsV4 } from "./NotificationTabsV4";

interface BodyProps {
  tabsContainerRef: (node: HTMLDivElement | null) => void;
  tabsContainerWidth: number;
}

export const Body = ({ tabsContainerWidth, tabsContainerRef }: BodyProps) => {
  const { activeTab, setActiveTab } = useNotificationContext();
  const tabs = useNotificationTabs();

  return (
    <NotificationTabsV4
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabsContainerRef={tabsContainerRef}
      tabsContainerWidth={tabsContainerWidth}
    />
  );
};
